import { IntituleLibreGroup } from './IntituleLibreGroup';
import { ChampLibreGroup } from './ChampLibreGroup';

export class RensComplementairesDivers {

  public intLibre: IntituleLibreGroup;
  public txtLibre: ChampLibreGroup;

  constructor() {
    this.intLibre = new IntituleLibreGroup();
    this.txtLibre = new ChampLibreGroup();
  }
}
